import * as yup from "yup"

export const productionPlanningValidationSchema = yup.object().shape({
  mode: yup.string().required("Mode is required"),
  officer: yup.object().nullable().required("Production Officer is required"),
  depot: yup.object().nullable().required("Production Depot is required"),
  start_date_time: yup.date().required("Start date is required"),
  output_items: yup
    .array()
    .of(
      yup.object().shape({
        commodity: yup.object().nullable().required("Commodity is required"),
        variety: yup.object().nullable().required("Variety is required"),
        details: yup
          .array()
          .required("At least one Output detail is required")
          .of(
            yup.object().shape({
              grade: yup.object().nullable().required("Grade is required"),
              qty: yup
                .string()
                .nullable()
                .required("Quantity is required")
                .test("is-number", "Quantity must be a number", value => {
                  if (value === null || value === undefined) return false
                  return !isNaN(Number(value))
                }),
              cost_per_unit: yup
                .string()
                .nullable()
                .required("Cost per unit is required")
                .test("is-number", "Cost per unit must be a number", value => {
                  if (value === null || value === undefined) return false
                  return !isNaN(Number(value))
                }),
            })
          )
          .min(1, "At least one Output grade is required"),
      })
    )
    .min(1, "At least one output item is required"),

  input_items: yup
    .array()
    .of(
      yup.object().shape({
        commodity: yup.object().nullable().required("Commodity is required"),
        variety: yup.object().nullable().required("Variety is required"),
        details: yup
          .array()
          .required("At least one Input detail is required")
          .of(
            yup.object().shape({
              storage_patti_refs: yup
                .string()
                .required("At least one reference is required"),
              grade: yup.object().nullable().required("Grade is required"),
              required_qty: yup
                .string()
                .nullable()
                .required("Required quantity is required")
                .test(
                  "is-number",
                  "Required quantity must be a number",
                  value => {
                    if (value === null || value === undefined) return false
                    return !isNaN(Number(value))
                  }
                )
                .test("is-greater-than-0", "Greater than 0", value => {
                  if (value === null || value === undefined) return false
                  return Number(value) > 0
                }),
              // used_qty: yup
              //   .string()
              //   .nullable()
              //   .required("Used quantity is required")
              //   .test("is-number", "Used quantity must be a number", value => {
              //     if (value === null || value === undefined) return false
              //     return !isNaN(Number(value))
              //   })
              //   .test("is-greater-than-0", "Greater than 0", value => {
              //     if (value === null || value === undefined) return false
              //     return Number(value) > 0
              //   }),
            })
          )
          .min(1, "At least one Input detail is required"),
      })
    )
    .min(1, "At least one input item is required"),

  packaging_items: yup
    .array()
    .of(
      yup.object().shape({
        commodity: yup.object().nullable().required("Commodity is required"),
        variety: yup.object().nullable().required("Variety is required"),
        details: yup
          .array()
          .required("At least one Packaging material is required")
          .of(
            yup.object().shape({
              storage_patti_refs: yup
                .string()
                .required("At least one reference is required"),
              grade: yup.object().nullable().required("Grade is required"),
              required_qty: yup
                .string()
                .nullable()
                .required("Required quantity is required")
                .test(
                  "is-number",
                  "Required quantity must be a number",
                  value => {
                    if (value === null || value === undefined) return false
                    return !isNaN(Number(value))
                  }
                )
                .test("is-greater-than-0", "Greater than 0", value => {
                  if (value === null || value === undefined) return false
                  return Number(value) > 0
                }),
              // used_qty: yup
              //   .string()
              //   .nullable()
              //   .required("Used quantity is required")
              //   .test("is-number", "Used quantity must be a number", value => {
              //     if (value === null || value === undefined) return false
              //     return !isNaN(Number(value))
              //   })
              //   .test("is-greater-than-0", "Greater than 0", value => {
              //     if (value === null || value === undefined) return false
              //     return Number(value) > 0
              //   }),
            })
          )
          .min(1, "At least one Packaging Material is required"),
      })
    )
    .min(1, "At least one Packaging Material is required"),
})
